import global from "../global.js";

const log = global.log.getLogger("f_mtac.ui.UserListArea");
log.setLevel(log.levels.WARN);

let UserListArea = function RoomListArea() {
    var { Modal } = window.f_mtac_theme;
    var user_list_area_modal;
    var selected = null;
    var interaction = null;

    var interaction_end = () => {
        user_list_area_modal.hide();
        if (interaction !== null) {
            interaction.resolve(selected);
        }
        interaction = null;
        selected = null;
    };

    $("body").on("click.user_list_area.btn", "#user_list_area button", (event) => {
        switch ($(event.target).data("method")) {
            case "cancel":
            case "close":
                selected = null;
                interaction_end();
                break;
            case "ok":
                selected = { login: $("#select-user").val(), name: $("#select-user")[0][$("#select-user")[0].selectedIndex].text };
                interaction_end();
                break;
        }
    });
    this.interact = async function () {
        user_list_area_modal = new Modal(document.getElementById("user_list_area"));
        global.users.sync();
        selected = null;
        user_list_area_modal.show();
        return new Promise(resolve => {
            interaction = { resolve };
        });
    };
};
export default new UserListArea();
